'use client';

import { Button } from '@/components/Buttons';
import * as stylex from '@stylexjs/stylex';
import '../../styles/tokens.stylex';
import { borderRadius, color, spacing } from '../../styles/tokens.stylex';
import { typography } from '../../styles/typography';
import { useEffect, useLayoutEffect } from 'react';
import { sendGTMEvent } from '@next/third-parties/google';
export interface MeetingDialogProps {
  dialogRef: (node: HTMLDialogElement) => void;
  meetingLink: string;
  closeDialog: (id: string) => void;
}
export function MeetingDialog({
  dialogRef,
  closeDialog,
  meetingLink
}: MeetingDialogProps) {
  function stopBubbleUp(e: MouseEvent) {
    e.stopPropagation();
  }
  const close = () => closeDialog(meetingLink);
  useLayoutEffect(() => {
    const create = window.hbspt?.meetings?.create;
    if (typeof create !== 'function') return;
    create('.meetings-iframe-container');
  }, [meetingLink]);
  useEffect(() => {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    function meetingBookSucceeded(event: MessageEvent<any>) {
      if (event.origin != 'https://meetings.hubspot.com') {
        return false;
      }
      if (event.data?.meetingBookSucceeded) {
        sendGTMEvent({
          event: 'hubspot_meeting_booked',
          meetingInfo: event.data.meetingsPayload,
          location: 'dialog'
        });
      }
    }
    window.addEventListener('message', meetingBookSucceeded);
    return () => {
      window.removeEventListener('message', meetingBookSucceeded);
    };
  }, [meetingLink]);
  return <dialog ref={dialogRef} className="xng3xce x11x033 xjbqb8w xh8yej3 xnlluxf xqirzj2" onClick={close} data-lock-scroll>
      <section
    //@ts-expect-error unknown type spat as per
    onClick={stopBubbleUp} className="x10a8y8t xpov14x xvueqy4 x11x033 x19i6xfm xixxii4 xzyprwq x1dtb55y xh8yej3">
        <header className="x1o4oh2x x6s0dn4 x78zum5">
          <div className="x2b8uid">
            <h1 {...stylex.props([typography.display2])}>Book a meeting</h1>
          </div>

          <div className="x1iyjqo2 x78zum5 x15zctf7">
            <Button onClick={close} iconOnly="x" variant="ghost" theme="neutral">
              Close Dialog
            </Button>
          </div>
        </header>
        <main className="x2b8uid x169mek3">
          <div data-src={`${meetingLink}?embed=true`} className="meetings-iframe-container"></div>
        </main>
      </section>
    </dialog>;
}